export default "__VITE_ASSET__qApmhrdC__"